import { render, staticRenderFns } from "./RiskDiagnosisForm.vue?vue&type=template&id=9d36e07e"
import script from "./RiskDiagnosisForm.vue?vue&type=script&lang=js"
export * from "./RiskDiagnosisForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports